module.exports = __webpack_public_path__ + "static/media/onda-violeta-2.3c7f3f68.png";